export { ServicesFiltersPage as default } from "./ServicesFiltersPage"; 